import React, { useState, useEffect, useRef } from "react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import CustomUploadAdapter from "./CustomUploadAdapter";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const EditProduct = ({ match }) => {
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [ProductTypes, setProductTypes] = useState("");
  const [sku, setsku] = useState("");
  const [retailprice, setretailprice] = useState(Number);
  const [productName, setName] = useState("");
  const [warrantyPeriod, setwarrantyPeriod] = useState("");
  const [originalPrice, setoriginalPrice] = useState(Number);
  const [sellingPrice, setsellingPrice] = useState(Number);
  const [quantity, setquantity] = useState(Number);
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64Image, setBase64Image] = useState(null);
  const [base64Images, setBase64Images] = useState([]);
  const [status, setChecked] = React.useState(Boolean);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [contactToPurchase, setcontactToPurchase] = React.useState(Boolean);
  const [bestseller, setbestseller] = React.useState(Boolean);
  const [brandId, setbrandId] = useState("");
  const [brandIdname, setbrandIdname] = useState("");
  const [category, setcategory] = useState([]);
  const [categoryId, setcategoryId] = useState("");
  const [categoryname, setcategoryname] = useState("");
  const [description, setDescription] = useState("");
  const editorRef = useRef(null);
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [brands, setbrands] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [imagess, setimagess] = useState([]);
  const [imagec, setimagec] = useState([]);
  const [parentCategoryID1, setParentCategoryID1] = useState([]);
  const [parentCategoryID2, setparentCategoryID2] = useState([]);
  const [specification, setspecification] = useState([]);
  let URL = `${process.env.REACT_APP_API_URL}/`;
  const [description1, setDescription1] = useState("");
  const [skuError, setSkuError] = useState("");
  const [productNameError, setProductNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [originalPriceError, setOriginalPriceError] = useState("");
  const [sellingPriceError, setSellingPriceError] = useState("");
  const [retailpriceError, setretailpriceError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [categoryIdError, setCategoryIdError] = useState("");
  const [brandIdError, setBrandIdError] = useState("");
  const [warrantyPeriodError, setWarrantyPeriodError] = useState("");
  const [SpecificationsError, setSpecificationsError] = useState("");
  const [urlvideo, seturlvideo] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const page = params.get("page") || 1;

  const handleCreate = async () => {
    const filteredSpecification = specification.filter(
      (spec) => spec.title.trim() !== "" && spec.content.trim() !== ""
    );
    // const filteredSpecification1 = specification.filter((spec) => spec.title.trim() === '' || spec.content.trim() === '');
    const filteredSpecificationFormatted = filteredSpecification.map(
      (item) => ({
        title: item.title.trim(),
        content: item.content.trim(),
      })
    );

    setProductData((prevProductData) => ({
      ...prevProductData,
      specification: filteredSpecificationFormatted,
    }));

    const updatedImageProduct = [...productData.imageProduct, ...selectedFiles];
    const updatedProductData = {
      ...productData,
      imageProduct: updatedImageProduct,
    };

    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    let isValid = true;
    if (!sku) {
      setSkuError("Vui lòng nhập SKU");
      isValid = false;
    } else {
      setSkuError("");
    }

    if (!productName) {
      setProductNameError("Vui lòng nhập Tên Sản Phẩm");
      isValid = false;
    } else {
      setProductNameError("");
    }

    if (!description) {
      setDescriptionError("Vui lòng nhập Mô Tả");
      isValid = false;
    } else {
      setDescriptionError("");
    }

    if (!originalPrice) {
      setOriginalPriceError("Vui lòng nhập Giá Gốc");
      isValid = false;
    } else {
      setOriginalPriceError("");
    }

    if (!sellingPrice) {
      setSellingPriceError("Vui lòng nhập Giá Bán");
      isValid = false;
    } else {
      setSellingPriceError("");
    }

    if (!categoryId) {
      setCategoryIdError("Vui lòng chọn Loại Sản Phẩm");
      isValid = false;
    } else {
      setCategoryIdError("");
    }

    if (!brandId) {
      setBrandIdError("Vui lòng chọn Hãng Sản Xuất");
      isValid = false;
    } else {
      setBrandIdError("");
    }
    if (retailprice === 0 || retailprice === "0") {
      setretailpriceError("Vui lòng nhập Giá Bán Lẻ");
      isValid = false;
    } else {
      setretailprice("");
    }
    if (!warrantyPeriod) {
      setWarrantyPeriodError("Vui lòng nhập Thời Gian Bảo Hành");
      isValid = false;
    } else {
      setWarrantyPeriodError("");
    }
    if (
      specification.some((spec) => spec.title === "" || spec.content === "")
    ) {
      setSpecificationsError(" Vui lòng không để title hoặc content trống");
      isValid = false;
      // console.log("productDatasssssssssss");
    }
    if (
      specification.some((spec) => spec.title === "" && spec.content === "")
    ) {
      // setSpecificationsError("Vui lòng không để title và content trống");
      isValid = true;
      // console.log("productData1111111");
    }
    // console.log("filteredSpecification", filteredSpecificationFormatted);
    //  console.log("productData", updatedProductData);
    //  console.log("descriptionrước", description);
    //  console.log("description1111", description1);
    if (isValid) {
      axios
        .put(
          `${process.env.REACT_APP_API_URL}/api/products/updateproduct/${sku}`,
          updatedProductData,
          config
        )
        .then((response) => {
          // console.log('Product updated successfully:', response.data);
          setShow(true);
        })
        .catch((error) => {
          console.error("Error updating product:", error);
        });
    }
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/products/get/${id}`)
      .then((response) => {
        const product = response.data;
        console.log("ASSA", product);
        setsku(product.product.sku);
        setName(product.product.productName);
        let modifiedDescription = response.data.product.description;
        // Replace <div class=\"frame-image\"><img ...><p class=\"title\">demo</p></div>
        // with <figure class="image"><img ...><figcaption>demo</figcaption></figure>
        modifiedDescription = modifiedDescription.replace(
          /<div class=\"frame-image\"><img src=\"([^"]+)\" alt=\"\"><p class=\"title\">([^<]+)<\/p><\/div>/g,
          '<figure class="image"><img src="$1" alt=""><figcaption>$2</figcaption></figure>'
        );

        // Replace <div class="title">DD</div> with <h3>DD</h3>
        modifiedDescription = modifiedDescription.replace(
          /<div class=\"title\">([^<]+)<\/div>/g,
          "<h3>$1</h3>"
        );
        modifiedDescription = modifiedDescription.replace(
          /<div class=\"title\">(<strong>[^<]+<\/strong>)<\/div>/g,
          "<h3>$1</h3>"
        );
        modifiedDescription = modifiedDescription.replace(
          /<div class=\"title\">(.+?)<\/strong><\/div>/g,
          "<h3>$1</strong></h3>"
        );
        // Replace <div class="title">DD</div> with <h3>DD</h3>
        modifiedDescription = modifiedDescription.replace(
          /<div class=\"title\">(.*?)<\/div>/g,
          "<h3>$1</h3>"
        );
        setDescription(modifiedDescription);

        setoriginalPrice(product.product.originalPrice);
        setsellingPrice(product.product.sellingPrice);
        setquantity(product.product.quantity);
        setretailprice(product.product.retailprice);
        setwarrantyPeriod(product.product.warrantyPeriod);
        setChecked(product.product.status);
        seturlvideo(product.product.urlvideo);
        setcontactToPurchase(product.product.contactToPurchase);
        setBase64Image(URL + product.product.urlImage);
        setspecification(response.data.specification);
        setcategoryId(response.data.product.categoryId);
        setcategoryname(response.data.category.name);
        setbrandId(response.data.product.brandId);
        setbestseller(response.data.product.bestseller);
        setbrandIdname(response.data.brand.name);
        setSelectedFiles(response.data.imageProduct);
        // console.log("description",product.product.description)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/brands/getbrands`)
      .then((response) => response.json())
      .then((data) => {
        setbrands(data.brands);
      })
      .catch((error) => console.log(error));
    fetch(`${process.env.REACT_APP_API_URL}/api/categories/getall`)
      .then((response) => response.json())
      .then((data) => {
        setcategory(data);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleInput1 = (e, setVariable) => {
    const inputText = e.target.value;
    const numericValue = parseFloat(inputText.replace(/[^0-9.]+/g, "")); // Allow decimals
    setVariable(isNaN(numericValue) ? 0 : numericValue);
  };

  const handleKeyPress1 = (event) => {
    const validKeys = /[0-9\b\r]/;
    if (!validKeys.test(event.key)) {
      event.preventDefault();
    }
  };
  const handleInput = (e, setVariable) => {
    const inputText = e.target.value;

    // Loại bỏ mọi ký tự không phải số để tránh lỗi tiếng Việt hoặc ký tự khác
    const numericText = inputText.replace(/\D/g, "");

    // Giá trị gốc (không định dạng)
    const rawValue = numericText.replace(/^0+/, ""); // Loại bỏ số 0 ở đầu

    // Nếu không có số, đặt giá trị rỗng
    if (!rawValue) {
      setVariable("");
      e.target.value = "";
      return;
    }

    // Định dạng với dấu chấm phân cách mỗi 3 chữ số
    const formattedValue = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Lưu giá trị gốc vào state, hiển thị giá trị định dạng trên input
    setVariable(rawValue);
    e.target.value = formattedValue;
  };

  const handleChange = () => {
    setChecked(!status);
  };
  const handleChange1 = () => {
    setcontactToPurchase(!contactToPurchase);
  };
  const handleChange1222 = () => {
    setbestseller(!bestseller);
  };
  useEffect(() => {
    const updatedDescription = description
      .replace(/<p>([^<]+)<\/p>/g, '<span class="content">$1</span>')
      .replace(
        /<p>([^<]+<strong>[^<]+<\/strong>[^<]+)<\/p>/g,
        '<span class="content">$1</span>'
      )
      .replace(/<p>([\s\S]+?)<\/p>/g, '<span class="content">$1</span>')
      .replace(/Base64 Image/, "")
      .replace(
        /<figure class="image"><img src="([^"]+)"><figcaption>([^<]+)<\/figcaption><\/figure>/g,
        '<div class="frame-image"><img src=$1 alt=\'\' /><p class="title">$2</p></div>'
      )
      .replace(
        /<h2><strong>([^<]+)<\/strong><\/h2>/g,
        '<div class="title"><strong>$1</strong></div>'
      )
      .replace(
        /<figure class="image"><img src="([^"]+)">(?:<figcaption>([^<]+)<\/figcaption>)?<\/figure>/g,
        '<div class="frame-image"><img src= $1 alt=\'\' /><p class="title">$2</p></div>'
      )
      .replace(
        /<figure class="image">(.+?)<\/figure>/g,
        '<div class="frame-image">$1</div>'
      )
      .replace(
        /<figcaption>([\s\S]*?)<\/figcaption>/g,
        '<p class="title">$1</p>'
      )
      .replace(
        /<img src="([^"]+)" alt="([^"]+)">/g,
        '<div class="frame-image"><img src="$1"alt=""/><p class="title">$2</p></div>'
      )
      .replace(
        /<span class="content"><img src="([^"]+)" alt=""><\/span>/g,
        '<div class="frame-image">\n  <img src="$1" alt="" />\n  <p class= "title"></p>\n</div>'
      )
      //h2
      .replace(/<h2>(.*?)<\/h2>/g, '<div class="title">$1</div>')
      .replace(
        /<h[2-4]><strong>([^<]+)<\/strong>([^<]+)<\/h[2-4]>/g,
        '<div class="title"><strong>$1</strong>$2</div>'
      )
      .replace(
        /<h[2-4]>([^<]+)<strong>([^<]+)<\/strong>([^<]+)<\/h[2-4]>/,
        '<div class="title">$1<strong>$2</strong>$3</div>'
      )
      .replace(
        /<h[2-4]>([^<]+)<strong>([^<]+)<\/strong><\/h[2-4]>/,
        '<div class="title">$1<strong>$2</strong></div>'
      )
      .replace(/<h2>([^<]+)<\/h2>/, '<div class="title">$1</div>')
      //h3
      .replace(/<h3>(.*?)<\/h3>/g, '<div class="title">$1</div>')
      .replace(
        /<h3><strong>([^<]+)<\/strong>([^<]+)<\/h3>/g,
        '<div class="title"><strong>$1</strong>$2</div>'
      )
      .replace(
        /<h3>([^<]+)<strong>([^<]+)<\/strong>([^<]+)<\/h3>/g,
        '<div class="title">$1<strong>$2</strong>$3</div>'
      )
      .replace(
        /<h3>([^<]+)<strong>([^<]+)<\/strong><\/h3>/g,
        '<div class="title">$1<strong>$2</strong></div>'
      )
      .replace(/<h3>([^<]+)<\/h3>/g, '<div class="title">$1</div>')
      //h4
      .replace(/<h4>(.*?)<\/h4>/g, '<div class="title">$1</div>')
      .replace(
        /<h4><strong>([^<]+)<\/strong>([^<]+)<\/h4>/g,
        '<div class="title"><strong>$1</strong>$2</div>'
      )
      .replace(
        /<h4>([^<]+)<strong>([^<]+)<\/strong>([^<]+)<\/h4>/g,
        '<div class="title">$1<strong>$2</strong>$3</div>'
      )
      .replace(
        /<h4>([^<]+)<strong>([^<]+)<\/strong><\/h4>/g,
        '<div class="title">$1<strong>$2</strong></div>'
      )
      .replace(/<h4>([^<]+)<\/h4>/g, '<div class="title">$1</div>')
      .replace(
        /<figure class="image">([\s\S]+?)<\/figure>/g,
        '<div class="frame-image"><img src=""alt=""/><p class="title"></p></div>'
      );

    setDescription1(updatedDescription);
  }, [description]);

  const [productData, setProductData] = useState({
    // brand: [],
    // category: [],
    imageProduct: [],
    product: [],
    specification: [],
    parentCategories: [],
  });

  useEffect(() => {
    setProductData((prevProductData) => ({
      ...prevProductData,
      product: {
        ...prevProductData.product,
        description: description1.trim(),
        sku: sku.trim(),
        productName: productName.trim(),
        urlvideo: urlvideo.trim(),
        originalPrice:
          typeof originalPrice === "string"
            ? parseFloat(
                originalPrice
                  .replace(/[^\d.]+/g, "")
                  .replace(".", "")
                  .replace(",", ".")
              )
            : originalPrice,
        sellingPrice:
          typeof sellingPrice === "string"
            ? parseFloat(
                sellingPrice
                  .replace(/[^\d.]+/g, "")
                  .replace(".", "")
                  .replace(",", ".")
              )
            : sellingPrice,
        retailprice:
          typeof retailprice === "string"
            ? parseFloat(
                retailprice
                  .replace(/[^\d.]+/g, "")
                  .replace(".", "")
                  .replace(",", ".")
              )
            : retailprice,
        quantity: quantity,
        brandId: brandId,
        categoryId: categoryId,
        warrantyPeriod: warrantyPeriod.trim(),
        contactToPurchase: contactToPurchase,
        bestseller: bestseller,
        status: status,
      },
    }));
  }, [
    retailprice,
    description1,
    sku,
    productName,
    originalPrice,
    sellingPrice,
    quantity,
    brandId,
    categoryId,
    warrantyPeriod,
    contactToPurchase,
    status,
    urlvideo,
    bestseller,
  ]);
  const handleFileSelect = (event) => {
    const file = event.target.files[0]; // Get the selected file from the input element

    if (file) {
      const reader = new FileReader(); // Create a new FileReader object
      reader.onload = (e) => {
        const base64Data = e.target.result; // Read the selected file as a base64 data URL
        setBase64Image(base64Data); // Update the state with the base64 data
        setSelectedFile(base64Data); // Update the selected file in the state
        const newImage = {
          sku: id,
          urlImage: base64Data,
          cardinal: true,
        };
        const newImages = [newImage];
        const updatedProductData = {
          ...productData,
          imageProduct: newImages,
        };
        setProductData(updatedProductData);
        // Log or perform any other actions with the selected file here
      };

      reader.readAsDataURL(file); // Read the selected file as a data URL
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFileDrop = (event) => {
    event.preventDefault();

    const file = event.dataTransfer.files[0]; // Get the dropped file
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Data = e.target.result;
        setBase64Image(base64Data);
        setSelectedFile(base64Data);
        const newImage = {
          sku: id,
          urlImage: base64Data,
          cardinal: true,
        };
        const newImages = [newImage];
        const updatedProductData = {
          ...productData,
          imageProduct: newImages,
        };
        setProductData(updatedProductData);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFileSelects = (event) => {
    const files = Array.from(event.target.files);

    // Copy the existing state to new variables
    const newFiles = [...selectedFiles];
    const newBase64Images = [...base64Images];

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Data = e.target.result;

        // Create an object with unique ID to track the file
        const newFile = {
          id: new Date().getTime(), // Unique ID
          urlImage: base64Data,
          cardinal: false,
        };

        newFiles.push(newFile);
        newBase64Images.push(base64Data);

        setSelectedFiles(newFiles);
        setBase64Images(newBase64Images);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const dt = event.dataTransfer;
    const files = Array.from(dt.files);
    handleFileSelects({ target: { files } });
  };
  const handleClearFile = (index) => {
    const newFiles = [...selectedFiles];
    const newBase64Images = [...base64Images];
    const newImages = [...imagess]; // Change the variable name here

    newFiles.splice(index, 1);
    newBase64Images.splice(index, 1);
    newImages.splice(index, 1);

    setSelectedFiles(newFiles);
    setBase64Images(newBase64Images);
    setimagess(newImages);
  };

  const handleNameChange = (e) => {
    setsku(e.target.value);
  };
  const handleNameChange1 = (e) => {
    setName(e.target.value);
  };
  const handleNameChange11 = (e) => {
    setwarrantyPeriod(e.target.value);
  };
  useEffect(() => {
    async function fetchData() {
      if (categoryId) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/categories/getid/${categoryId}`
          );
          const dataFromAPI = await response.json();
          // console.log("dataFromAPI", dataFromAPI);
          // console.log("parentCategoryID", dataFromAPI.parentCategoryID);

          const newData = {
            categoryID: dataFromAPI.categoryID,
            name: dataFromAPI.name,
            parentCategoryID: dataFromAPI.parentCategoryID,
          };

          // Update parentCategoryID1
          setParentCategoryID1((prevParentCategoryID1) => [
            ...prevParentCategoryID1,
            newData,
          ]);

          // console.log("newData1", newData);

          // Perform the second API call
          if (dataFromAPI.parentCategoryID) {
            const response2 = await fetch(
              `${process.env.REACT_APP_API_URL}/api/categories/getid/${dataFromAPI.parentCategoryID}`
            );
            const dataFromAPI2 = await response2.json();
            const newData2 = {
              categoryID: dataFromAPI2.categoryID,
              name: dataFromAPI2.name,
              parentCategoryID: dataFromAPI2.parentCategoryID,
            };

            // Update parentCategoryID2
            setparentCategoryID2((prevParentCategoryID2) => [
              ...prevParentCategoryID2,
              newData2,
            ]);

            // console.log("newData2", newData2);

            // Update the ProductData state
            setProductData((prevProductData) => ({
              ...prevProductData,
              parentCategories: [
                ...prevProductData.parentCategories,
                newData,
                newData2,
              ],
            }));
          }
        } catch (error) {
          console.log(error);
        }
      }
    }

    fetchData();
  }, [categoryId]);

  const handleNameChange67 = (event) => {
    const selectedCategoryId = event.target.value;
    setProductData((prevProductData) => ({
      ...prevProductData,
      parentCategories: [], // Reset parentCategories to an empty array
    }));
    setcategoryId(selectedCategoryId);
    // console.log("categoryId", selectedCategoryId);
  };
  const handleNameChangev = (e) => {
    setbrandId(e.target.value);
  };

  const handleEditorChange = (event, editor) => {
    try {
      const data = editor.getData();
      setDescription(data);
    } catch (error) {
      console.error("Error in handleEditorChange:", error);
    }
  };
  const [newSpec, setNewSpec] = useState({
    title: "",
    content: "",
  });
  useEffect(() => {
    const filteredSpecification = specification.filter(
      (item) => item.title !== "" || item.content !== ""
    );

    const filteredSpecificationFormatted = filteredSpecification.map(
      (item) => ({
        id: item._id, // Update 'id' from '_id'
        title: item.title,
        content: item.content,
        sku: sku,
      })
    );

    setProductData((prevProductData) => ({
      ...prevProductData,
      specification: filteredSpecificationFormatted,
    }));
  }, [specification, productData.product.sku]);

  const handleAddRow = () => {
    const newRow = {
      title: "",
      content: "",
    };

    setspecification([...specification, newRow]);
    // console.log()
  };
  const handleNameChange13 = (e) => {
    seturlvideo(e.target.value);
  };

  const handleInputChanges = (index, field, value) => {
    const updatedSpecification = [...specification];
    if (updatedSpecification[index]) {
      updatedSpecification[index][field] = value;
      setspecification(updatedSpecification);
    }
  };
  const handleClose = () => {
    navigate(`/admin/products/list?page=${page}`);
    setShow(false);
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>THÀNH CÔNG</Modal.Title>
        </Modal.Header>
        <Modal.Body>SẢN PHẨM ĐÃ ĐƯỢC THAY ĐỔI THÀNH CÔNG</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Cập nhật sản phẩm
            </h1>
            <p className="text-gray-600 mt-1">
              Chỉnh sửa thông tin sản phẩm: {sku}
            </p>
          </div>
          <button
            onClick={() => navigate(`/admin/products/list?page=${page}`)}
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          >
            ← Quay lại danh sách
          </button>
        </div>
      </div>

      <div className="  overflow-y-auto h-[calc(100vh-100px)] px-20 py-4">
        <form
          className="space-y-8"
          encType="multipart/form-data"
          disabled={isFormDisabled}
        >
          {/* Thông tin cơ bản */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Thông tin cơ bản
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* SKU */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  SKU <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={sku}
                  onChange={handleNameChange}
                  disabled={true}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500 cursor-not-allowed"
                  placeholder="Mã SKU (không thể thay đổi)"
                />
                {skuError && (
                  <div className="text-red-500 text-sm mt-1">{skuError}</div>
                )}
              </div>

              {/* Thời gian bảo hành */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Thời gian bảo hành <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={warrantyPeriod}
                  onChange={handleNameChange11}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="VD: 12 tháng"
                />
                {warrantyPeriodError && (
                  <div className="text-red-500 text-sm mt-1">
                    {warrantyPeriodError}
                  </div>
                )}
              </div>
            </div>

            {/* Tên sản phẩm */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tên sản phẩm <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                rows="2"
                value={productName}
                onChange={handleNameChange1}
                placeholder="Nhập tên sản phẩm"
              />
              {productNameError && (
                <div className="text-red-500 text-sm mt-1">
                  {productNameError}
                </div>
              )}
            </div>

            {/* Mô tả */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mô tả sản phẩm <span className="text-red-500">*</span>
              </label>
              <div className="border border-gray-300 rounded-lg overflow-hidden">
                <CKEditor
                  editor={ClassicEditor}
                  data={description}
                  onChange={handleEditorChange}
                  config={{
                    extraPlugins: [CustomUploadAdapter],
                  }}
                  onReady={(editor) => {
                    editor.plugins.get("FileRepository").createUploadAdapter = (
                      loader
                    ) => {
                      return new CustomUploadAdapter(loader);
                    };
                    editorRef.current = editor;
                  }}
                />
              </div>
              {descriptionError && (
                <div className="text-red-500 text-sm mt-1">
                  {descriptionError}
                </div>
              )}
            </div>

            {/* Link Video */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Link video
              </label>
              <textarea
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                rows="2"
                value={urlvideo}
                onChange={handleNameChange13}
                placeholder="Nhập link video YouTube hoặc URL khác"
              />
            </div>
          </div>

          {/* Giá và số lượng */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Giá và số lượng
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Giá gốc */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Giá gốc (VND) <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={originalPrice.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })}
                  value={originalPrice.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })}
                  onChange={(e) => handleInput(e, setoriginalPrice)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {originalPriceError && (
                  <div className="text-red-500 text-sm mt-1">
                    {originalPriceError}
                  </div>
                )}
              </div>

              {/* Giá bán */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Giá bán (VND) <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={sellingPrice.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })}
                  value={sellingPrice.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })}
                  onChange={(e) => handleInput(e, setsellingPrice)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {sellingPriceError && (
                  <div className="text-red-500 text-sm mt-1">
                    {sellingPriceError}
                  </div>
                )}
              </div>

              {/* Giá bán sỉ */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Giá bán sỉ (VND) <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={(retailprice || 0).toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })}
                  value={(retailprice || 0).toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })}
                  onChange={(e) => handleInput(e, setretailprice)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {retailpriceError && (
                  <div className="text-red-500 text-sm mt-1">
                    {retailpriceError}
                  </div>
                )}
              </div>

              {/* Số lượng */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Số lượng <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={quantity}
                  value={quantity}
                  onInput={(e) => handleInput1(e, setquantity)}
                  onKeyPress={handleKeyPress1}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {quantityError && (
                  <div className="text-red-500 text-sm mt-1">
                    {quantityError}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Phân loại */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Phân loại sản phẩm
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Loại sản phẩm */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Loại sản phẩm <span className="text-red-500">*</span>
                </label>
                <select
                  value={categoryId}
                  onChange={handleNameChange67}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white"
                >
                  <option value="">Chọn loại sản phẩm</option>
                  {category.map((category) => (
                    <option
                      key={category.categoryID}
                      value={category.categoryID}
                    >
                      {category.name}
                    </option>
                  ))}
                </select>
                {categoryIdError && (
                  <div className="text-red-500 text-sm mt-1">
                    {categoryIdError}
                  </div>
                )}
              </div>

              {/* Hãng sản xuất */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Hãng sản xuất <span className="text-red-500">*</span>
                </label>
                <select
                  value={brandId}
                  onChange={handleNameChangev}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white"
                >
                  <option value="">Chọn hãng sản xuất</option>
                  {brands.map((brands) => (
                    <option key={brands.idBrand} value={brands.idBrand}>
                      {brands.name}
                    </option>
                  ))}
                </select>
                {brandIdError && (
                  <div className="text-red-500 text-sm mt-1">
                    {brandIdError}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Hình ảnh */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Hình ảnh sản phẩm
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Ảnh chính */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ảnh chính
                </label>
                <div
                  onDrop={handleFileDrop}
                  onDragOver={handleDragOver}
                  className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 transition-colors"
                >
                  <label className="cursor-pointer block">
                    <input
                      type="file"
                      multiple
                      onChange={handleFileSelect}
                      className="hidden"
                    />
                    <div className="text-gray-500">
                      <svg
                        className="mx-auto h-12 w-12 mb-4"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-sm">
                        Chọn ảnh hoặc kéo và thả ảnh vào đây
                      </span>
                    </div>
                  </label>
                  {base64Image && (
                    <div className="mt-4">
                      <img
                        src={
                          base64Image.startsWith(URL + URL)
                            ? base64Image.replace(URL, "")
                            : base64Image
                        }
                        alt="Preview"
                        className="w-20 h-20 object-cover rounded-lg mx-auto border border-gray-200"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Ảnh phụ */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ảnh phụ
                </label>
                <div
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 transition-colors"
                >
                  <label className="cursor-pointer block">
                    <input
                      type="file"
                      multiple
                      onChange={handleFileSelects}
                      className="hidden"
                    />
                    <div className="text-gray-500">
                      <svg
                        className="mx-auto h-12 w-12 mb-4"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-sm">
                        Chọn nhiều ảnh hoặc kéo và thả ảnh vào đây
                      </span>
                    </div>
                  </label>
                  {selectedFiles.length > 0 && (
                    <div className="mt-4 flex flex-wrap gap-2 justify-center">
                      {selectedFiles.map((file, index) => {
                        // Xử lý URL để tránh bị lặp
                        let imageUrl = file.urlImage;

                        // Loại bỏ tất cả các phần lặp của URL gốc, chỉ giữ một lần duy nhất
                        while (imageUrl.startsWith(URL + URL)) {
                          imageUrl = imageUrl.replace(URL, "");
                        }

                        // Nếu vẫn bắt đầu với URL, đảm bảo chỉ có một lần
                        if (
                          !imageUrl.startsWith(URL) &&
                          !imageUrl.startsWith("data:image")
                        ) {
                          imageUrl = URL + imageUrl;
                        }

                        return (
                          <div key={file.id} className="relative">
                            <img
                              src={imageUrl}
                              alt="Preview"
                              className="w-16 h-16 object-cover rounded-lg border border-gray-200"
                            />
                            <button
                              type="button"
                              onClick={() => handleClearFile(index)}
                              className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full text-xs flex items-center justify-center hover:bg-red-600 transition-colors"
                            >
                              ×
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Cài đặt */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Cài đặt sản phẩm
            </h2>

            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={status}
                  onChange={handleChange}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label className="ml-3 text-sm font-medium text-gray-700">
                  Trạng thái hoạt động
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={contactToPurchase}
                  onChange={handleChange1}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label className="ml-3 text-sm font-medium text-gray-700">
                  Hiển thị giá
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={bestseller}
                  onChange={handleChange1222}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label className="ml-3 text-sm font-medium text-gray-700">
                  Sản phẩm nổi bật
                </label>
              </div>
            </div>
          </div>

          {/* Thông số kỹ thuật */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Thông số kỹ thuật
            </h2>

            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4 font-medium text-gray-700">
                      Tên thông số
                    </th>
                    <th className="text-left py-3 px-4 font-medium text-gray-700">
                      Giá trị
                    </th>
                  </tr>
                </thead>
                <tbody className="space-y-2">
                  {specification.map((element, index) => (
                    <tr key={index} className="border-b border-gray-100">
                      <td className="py-3 px-4">
                        <textarea
                          type="text"
                          name="title"
                          value={element.title}
                          onChange={(e) =>
                            handleInputChanges(index, "title", e.target.value)
                          }
                          placeholder="Nhập tên thông số"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                          rows="2"
                        />
                      </td>
                      <td className="py-3 px-4">
                        <textarea
                          type="text"
                          name="content"
                          value={element.content}
                          onChange={(e) =>
                            handleInputChanges(index, "content", e.target.value)
                          }
                          placeholder="Nhập giá trị"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                          rows="2"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {SpecificationsError && (
                <div className="text-red-500 text-sm mt-2">
                  {SpecificationsError}
                </div>
              )}
            </div>

            <button
              type="button"
              onClick={handleAddRow}
              className="mt-4 inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              + Thêm thông số
            </button>
          </div>

          {/* Submit button */}
          <div className="flex justify-end space-x-4 pt-6">
            <button
              type="button"
              onClick={() => navigate(`/admin/products/list?page=${page}`)}
              className="px-6 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              Hủy
            </button>
            <button
              type="button"
              onClick={handleCreate}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm"
            >
              Cập nhật sản phẩm
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default EditProduct;
